module.exports = __webpack_public_path__ + "static/media/image4.1e8a0d9a.jpg";